// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import {
    readLatestPerUnitMeasurements,
    resetLatestPerUnitMeasurements
} from '../../../../shared/action-creators/latest-per-unit-measurements';
import actions from '../../../action-list';
import {canGetProductCustomer} from '../../../../shared/services/privacy';
import {doesAccountHaveMatch} from '../../../shared/services/claim-shared-helper';
import {getDetails} from '../../../../product/shared/repositories';
import {readCustomer} from './get-customer-details';
import {readLaborTypes} from '../../../shared/action-creators/labor-types';

const updateResponsibleAccount = (accountId, productAccountId, dealerCollection, dispatch) => {

    if (!accountId && doesAccountHaveMatch(productAccountId, dealerCollection)) {

        dispatch({
            accountId: productAccountId,
            dealers: dealerCollection,
            type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_RESPONSIBLE_ACCOUNT
        });

    }

    if (accountId) {

        readLaborTypes(accountId)(dispatch);

    }

};

export const readClaimProduct = pin =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getDetails(pin);

            const accountId = getState().claims.mccFollowup.claim.responsibleAccount.account;

            const dealerCollection = getState().user.details.settings.dealer.accounts.allowedAccounts;

            dispatch({
                data,
                type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_PRODUCT_DETAILS
            });

            if (canGetProductCustomer(data)) {

                readCustomer(data.customerSummary.id, data.customerPrivate)(dispatch);

            }

            updateResponsibleAccount(accountId, data.dealer.account, dealerCollection, dispatch);

            if (!getState().claims.mccFollowup.claim.sellingDealer.key) {

                dispatch({
                    key: data.invoicedDealer.account,
                    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_SELLING_DEALER,
                    value: data.invoicedDealer.name
                });

            }

            readLatestPerUnitMeasurements(pin)(dispatch);

        } catch (error) {

            dispatch({
                type: actions.RESET_CLAIM_MCC_FOLLOWUP_PRODUCT_DETAILS
            });

            resetLatestPerUnitMeasurements()(dispatch);

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/get-product-details.js